const columnsAllDepartmentGroup = [
  {
    key: "no",
    title: "#",
    scopedSlots: { customRender: "no" },
    width: 70,
  },

  {
    key: "name",
    title: "Name",
    dataIndex: "name",
  },
  {
    key: "code",
    title: "Code",
    dataIndex: "code",
  },
  {
    key: "departments",
    title: "Department",
    // dataIndex: ["departments", "name"],
    scopedSlots: { customRender: "departments" },
  },
  {
    title: "Created at",
    key: "createdAt",
    dataIndex: "createdAt",
    scopedSlots: { customRender: "createdAt" },
  },
  {
    title: "Updated at",
    key: "updatedAt",
    dataIndex: "updatedAt",
    scopedSlots: { customRender: "updatedAt" },
  },
  {
    title: "",
    key: "action",
    scopedSlots: { customRender: "action" },
    fixed: "right",
  },
];

export { columnsAllDepartmentGroup };
